import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaOverviewPlazamapPage } from './plaza-overview-plazamap';

@NgModule({
  declarations: [
    PlazaOverviewPlazamapPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaOverviewPlazamapPage),
    TranslateModule.forChild()
  ],
})
export class PlazaOverviewPlazamapPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview-plazamap/plaza-overview-plazamap.module.ts